export default {
  tenants: [
    'test',
    'hybris',
    'stockton',
    'autotest-one',
    'autotest-two',
    'flight-extras',
    'atcom',
  ],
}
